import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { ASPConfig } from '@module/config/type';
import { useQuery } from '@tanstack/react-query';

export const aspAuthQueryKeys = createQueryKeys('asp', {
  auth: null,
});

export const useASPAuthQuery = () => {
  return useQuery<ASPConfig>({
    queryKey: aspAuthQueryKeys.auth.queryKey,
    enabled: false,
    // do not fetch authomatically, and do not remove from cache
    staleTime: Infinity,
  });
};
